import { toDateTime } from 'utils/dates';

export default function FormattedDateTitle({
  date,
  prefix,
}: {
  date?: string;
  prefix?: string;
}) {
  const displayDate = date ? toDateTime(date).toFormat('MM/dd/yy') : '-';
  return (
    <>
      {prefix} {displayDate}
    </>
  );
}
